import type { RouteRecordRaw } from 'vue-router'
import { ROUTE_ROLES } from '@/utils/permissions'

const routes: RouteRecordRaw[] = [
  {
    path: '/issuer-profiles',
    name: 'IssuerProfiles',
    component: () => import('@/views/issuerProfiles/index.vue'),
    meta: {
      title: '茶商准入',
      permission: 'issuer:manage',
      roles: ROUTE_ROLES.issuerProfiles
    }
  },
  {
    path: '/issuer-profiles/detail/:id',
    name: 'IssuerProfileDetail',
    component: () => import('@/views/issuerProfiles/detail.vue'),
    meta: {
      title: '企业详情',
      permission: 'issuer:manage',
      roles: ROUTE_ROLES.issuerProfiles,
      hidden: true
    }
  }
]

export default routes
